import {useTheme} from "next-themes"
import {Toaster as Sonner} from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ theme: propsTheme, ...props }: ToasterProps): React.ReactElement => {
  const { theme = "system" } = useTheme()

 // Use props theme if provided, otherwise use theme from useTheme (defaults to "system")
  const resolvedTheme = (propsTheme ?? theme) as "light" | "dark" | "system"

 return (
 <Sonner
 theme={resolvedTheme}
 className="toaster group"
 position="top-right"
 toastOptions={{
 classNames: {
 toast:
            "group toast group-[.toaster]:liquid-glass group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:border-[hsl(var(--liquid-glass-border-medium))] group-[.toaster]:shadow-liquid-glass group-[.toaster]:rounded-2xl group-[.toaster]:p-4 group-[.toaster]:animate-fluid-appear",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-sm group-[.toast]:mt-1",
 actionButton:
            "group-[.toast]:fluid-button group-[.toast]:bg-[hsl(var(--liquid-glass-regular))] group-[.toast]:text-foreground group-[.toast]:rounded-xl group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:font-medium group-[.toast]:border group-[.toast]:border-[hsl(var(--liquid-glass-border-light))]",
 cancelButton:
            "group-[.toast]:fluid-button group-[.toast]:bg-transparent group-[.toast]:text-muted-foreground group-[.toast]:rounded-xl group-[.toast]:px-4 group-[.toast]:py-2 group-[.toast]:font-medium group-[.toast]:border group-[.toast]:border-[hsl(var(--liquid-glass-border-light))]",
          success: "group-[.toast]:border-success/30 group-[.toast]:bg-[hsl(var(--success-background))]",
          error: "group-[.toast]:border-error/30 group-[.toast]:bg-[hsl(var(--error-background))]",
          warning: "group-[.toast]:border-warning/30 group-[.toast]:bg-[hsl(var(--warning-background))]",
          info: "group-[.toast]:border-info/30 group-[.toast]:bg-[hsl(var(--info-background))]",
 },
 style: {
 fontFamily: 'system-ui, -apple-system, sans-serif',
 },
 }}
 {...props}
 />
 )
}

export { Toaster }
